import React from 'react'
import { Spinner, Table } from 'react-bootstrap'
import TableReportRow from './TableReportRow'

const TableReport = ({ subjects, setShowReportDetail, setReport, loading, generateActividadesPdf }) => {
    return (
        <Table>
            <thead>
                <tr>
                    <th colSpan={2}></th>
                    <th colSpan={2} className='text-center'>
                        Control asistencia
                    </th>
                    <th colSpan={2} className='text-center'>
                        Control permanencia
                    </th>
                    <th></th>
                </tr>
                <tr>
                    <th style={{ width: '40%' }}>Materia</th>
                    <th className='text-center'>Grupo</th>
                    <th className='text-center'>Asistencias</th>
                    <th className='text-center'>Inasistencias</th>
                    <th className='text-center'>Completos</th>
                    <th className='text-center'>Incompletos</th>
                    <th className='text-center' style={{ width: '7rem' }}>
                        Ver Más
                    </th>
                </tr>
            </thead>
            <tbody>
                {subjects && subjects.length > 0 ? (
                    subjects.map((subject) => (
                        <TableReportRow
                            key={subject.id}
                            subject={subject}
                            setShowReportDetail={setShowReportDetail}
                            setReport={setReport}
                            generateActividadesPdf={generateActividadesPdf}
                        />
                    ))
                ) : (
                    <tr style={{ textAlign: 'center' }}>
                        <td colSpan={6}>{loading ? <Spinner variant='blue' size='sm' /> : 'No existen reportes.'}</td>
                    </tr>
                )}
            </tbody>
        </Table>
    )
}

export default TableReport
